const URL_SHORTENERS = [
  "bit.ly",
  "bitly.com",
  "tinyurl.com",
  "t.co",
  "goo.gl",
  "ow.ly",
  "is.gd",
  "buff.ly",
  "rebrand.ly",
  "bl.ink",
  "short.io",
  "cutt.ly",
  "lnkd.in",
  "rb.gy",
  "shorturl.at",
  "tiny.cc",
  "soo.gd",
  "s.id",
];

const FILE_SHARING = [
  "dropbox.com",
  "dl.dropboxusercontent.com",
  "wetransfer.com",
  "we.tl",
  "mega.nz",
  "mega.co.nz",
  "mediafire.com",
  "sendspace.com",
  "zippyshare.com",
];

export const BLOCKED_DOMAINS = [...URL_SHORTENERS, ...FILE_SHARING];

function extractBaseDomain(hostname: string): string {
  const parts = hostname.toLowerCase().replace(/^www\./, "").split(".");
  if (parts.length <= 2) return parts.join(".");
  const twoPartTlds = ["co.nz", "co.uk", "com.au", "co.jp"];
  const lastTwo = parts.slice(-2).join(".");
  if (twoPartTlds.includes(lastTwo)) {
    return parts.slice(-3).join(".");
  }
  return parts.slice(-2).join(".");
}

export function validateLinkUrl(url: string): { valid: boolean; error?: string } {
  const trimmed = url.trim();
  if (!trimmed) {
    return { valid: false, error: "URL cannot be empty" };
  }

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return { valid: false, error: "Invalid URL format" };
  }

  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
    return { valid: false, error: "Only http and https URLs are allowed" };
  }

  const hostname = parsed.hostname.toLowerCase().replace(/^www\./, "");
  const baseDomain = extractBaseDomain(parsed.hostname);

  for (const blocked of BLOCKED_DOMAINS) {
    if (hostname === blocked || baseDomain === blocked) {
      if (URL_SHORTENERS.includes(blocked)) {
        return { valid: false, error: "URL shorteners are not allowed — use the full destination URL instead" };
      }
      return { valid: false, error: "File-sharing links are not allowed — use a direct URL instead" };
    }
  }

  return { valid: true };
}
